import ItemNames from "../../mixins/item-name-list-search";
import ChecklistItemForm from "../../mixins/checklist-item-form";

Vue.component("checklist-item-edit-form", {

  mixins: [ChecklistItemForm, ItemNames],

  props: ["item"],

  data() {
    return {
      checklistItem: this.item,
      form: new AppForm({})
    };
  },

  watch: {

    "item": function(newVal) {
      this.checklistItem = newVal;
    }

  },

  computed: {

    hasCleanlinessValue() {
      return this.checklistItem.cleanliness;
    },

    hasDamageValue() {
      return this.checklistItem.damage;
    },

    hasFunctioningValue() {
      return this.checklistItem.functioning;
    }

  },

  methods: {

    save() {

      this.form.item = this.checklistItem.item;
      this.form.cleanliness = this.checklistItem.cleanliness;
      this.form.damage = this.checklistItem.damage;
      this.form.functioning = this.checklistItem.functioning;
      this.form.recommendation = this.checklistItem.recommendation;
      this.form.comments = this.checklistItem.comments;

      App.patch("/inspections/items/" + this.checklistItem.id + "/update", this.form)
        .then(response => {
          this.checklistItem = response;
          this.form = new AppForm({});

          $("#modal-checklist-item-edit-form").modal("hide");

          this.$emit("item-updated", response);

        })
        .catch(errors => {
          toastr.errors(errors);
        });

    },

    setCleanliness(cleanliness = null) {
      this.checklistItem.cleanliness = cleanliness;
    },

    setDamage(damage = null) {
      this.checklistItem.damage = damage;
    },

    setFunctioning(functioning = null) {
      this.checklistItem.functioning = functioning;
    },

    cancelEditing() {
      $("#modal-checklist-item-edit-form").modal("hide");
    },

    fetchRecommendations (queryString, cb) {
      cb(this.state.currentTeam.inspection_settings.recommendations.map(r => {return {"value": r};}));
    }

  }

});
